module.exports = __webpack_public_path__ + "static/index/img/baikal-301.bf7f6df4.jpg";